// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"7a46a43b","124":"705d4919","453":"74805e59","655":"f73d17b2","809":"480562d0","997":"6475c9f9"}[chunkId] + ".chunk.js";
};